import type { ReactNode, ThHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

/** Wide tables scroll inside their own container, never the page body. */
export const TableWrap = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className={cn('w-full overflow-x-auto', className)}>{children}</div>
);

export const Table = ({ children, className }: { children: ReactNode; className?: string }) => (
  <table className={cn('w-full border-collapse text-left text-[13px]', className)}>{children}</table>
);

export const Th = ({
  children,
  className,
  ...props
}: ThHTMLAttributes<HTMLTableCellElement> & { children?: ReactNode }) => (
  <th
    scope="col"
    className={cn(
      'whitespace-nowrap border-b border-border px-3 py-2 text-[12px] font-semibold uppercase tracking-wide text-ink-subtle',
      className,
    )}
    {...props}
  >
    {children}
  </th>
);

export const Td = ({ children, className }: { children?: ReactNode; className?: string }) => (
  <td className={cn('border-b border-border px-3 py-2 align-middle text-ink', className)}>
    {children}
  </td>
);

export const Tr = ({
  children,
  className,
  onClick,
}: {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}) => (
  <tr
    className={cn(onClick ? 'cursor-pointer hover:bg-canvas' : undefined, className)}
    onClick={onClick}
  >
    {children}
  </tr>
);
